var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHistoryReceive = function SvgHistoryReceive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.85,
    d: "M14.427 7.32H3.98l6.253-5.427c.1-.088.04-.25-.093-.25H8.56a.3.3 0 0 0-.188.07L1.625 7.566a.57.57 0 0 0 0 .863l6.787 5.89a.14.14 0 0 0 .092.036h1.634a.142.142 0 0 0 .093-.25L3.98 8.678h10.447a.143.143 0 0 0 .143-.143V7.464a.143.143 0 0 0-.143-.143"
  })));
};
export default SvgHistoryReceive;